import { jsx as r, jsxs as f } from "react/jsx-runtime";
import { c as S } from "react/compiler-runtime";
import T from "@mui/icons-material/Info";
import * as v from "react";
import "@mui/material";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import { Box as h } from "../../atoms/Box/Box.js";
import { FormLabel as W } from "../../atoms/FormLabel/FormLabel.js";
import { Grid as I } from "../../atoms/Grid/Grid.js";
import { Typography as b } from "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "../../organisms/ReactMap/hooks.js";
import "@mui/icons-material/Clear";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "@mui/icons-material/Menu";
import "../../../fetch/fetchConfig.js";
import "immer";
import { FormControl as k } from "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import { Tooltip as j } from "../../atoms/Tooltip/Tooltip.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/material/Typography";
function Sr(o) {
  const t = S(18), {
    title: x,
    children: g,
    data: s,
    icon: a,
    style: u,
    titleTooltip: d,
    id: y
  } = o;
  let i;
  t[0] !== a ? (i = a ? /* @__PURE__ */ r(h, { component: "span", sx: l.legendIconWrap, children: a }) : null, t[0] = a, t[1] = i) : i = t[1];
  let p;
  t[2] !== x ? (p = /* @__PURE__ */ r(h, { component: "span", sx: l.legendTitle, children: x }), t[2] = x, t[3] = p) : p = t[3];
  let m;
  t[4] !== d ? (m = d ? /* @__PURE__ */ r(j, { title: d, placement: "top", children: /* @__PURE__ */ r(h, { component: "span", sx: l.legendIconWrap, children: /* @__PURE__ */ r(T, { fontSize: "small" }) }) }) : null, t[4] = d, t[5] = m) : m = t[5];
  let e;
  t[6] !== i || t[7] !== p || t[8] !== m ? (e = /* @__PURE__ */ f(W, { component: "legend", sx: l.legend, children: [
    i,
    p,
    m
  ] }), t[6] = i, t[7] = p, t[8] = m, t[9] = e) : e = t[9];
  let n;
  t[10] !== s ? (n = s && /* @__PURE__ */ r(I, { container: !0, rowGap: 1, alignItems: "start", children: s.map(w) }), t[10] = s, t[11] = n) : n = t[11];
  let c;
  return t[12] !== g || t[13] !== y || t[14] !== u || t[15] !== e || t[16] !== n ? (c = /* @__PURE__ */ f(k, { id: y, component: "fieldset", sx: l.fieldset, fullWidth: !0, style: u, children: [
    e,
    g,
    n
  ] }), t[12] = g, t[13] = y, t[14] = u, t[15] = e, t[16] = n, t[17] = c) : c = t[17], c;
}
function w(o, t) {
  return o.hide ? null : /* @__PURE__ */ f(v.Fragment, { children: [
    o.key?.toString() && /* @__PURE__ */ f(I, { xs: 4, display: "flex", justifyContent: "space-between", style: {
      marginTop: "4px"
    }, children: [
      /* @__PURE__ */ r(b, { color: "grey", component: "span", sx: {
        fontSize: {
          xs: 12,
          sm: 13
        }
      }, children: o.key }),
      ":  "
    ] }),
    /* @__PURE__ */ r(I, { xs: o.key?.toString().length ? 8 : 12, sx: l.value, style: {
      marginTop: "4px",
      alignItems: "center"
    }, children: typeof o.value == "function" ? o.value() : o.value })
  ] }, t);
}
const l = {
  fieldset: (o) => ({
    border: "1px solid var(--border-color)",
    borderRadius: {
      xs: 0.5,
      sm: 1
    },
    padding: {
      xs: 1,
      sm: 2
    },
    marginBottom: {
      xs: 1,
      sm: 2
    },
    [o.breakpoints.down("sm")]: {
      margin: "0 4px 8px 4px"
    }
  }),
  legend: {
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.5,
    fontSize: {
      xs: 12,
      sm: 14
    },
    color: "var(--primary)",
    fontWeight: {
      xs: 600,
      sm: 500
    },
    lineHeight: 1.25
  },
  legendTitle: {
    display: "inline-flex",
    alignItems: "center"
  },
  legendIconWrap: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 0,
    flexShrink: 0
  },
  value: {
    display: "flex",
    textWrap: "pretty",
    fontSize: {
      xs: 12,
      sm: 13
    }
  }
};
export {
  Sr as SummaryTemplate,
  Sr as default
};
